import { Button, Popconfirm } from 'antd';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';

export function getOutletsTable(handleAction) {
  return [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) => a.id - b.id,
      fixed: 'left',
    },
    {
      title: 'Outlet Name',
      dataIndex: 'outlet_desc',
      key: 'outlet_desc',
      sorter: (a, b) => a.outlet_desc.localeCompare(b.outlet_desc),
    },
    {
      title: 'Outlet Address',
      dataIndex: 'outlet_address',
      key: 'outlet_address',
      sorter: (a, b) => a.outlet_address.localeCompare(b.outlet_address),
    },
    {
      title: 'Outlet Contact',
      dataIndex: 'outlet_contact',
      key: 'outlet_contact',
      sorter: (a, b) => a.outlet_contact.localeCompare(b.outlet_contact),
    },
  
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <>
          <Button
            type="primary"
            onClick={() => handleAction(record.id, 'edit')}
            icon={<AiFillEdit size={20} />}
            className="mx-2"
          >
            Edit
          </Button>
          <Popconfirm
            title={`Are you sure to delete ${record.outlet_desc}?`}
            onConfirm={() => handleAction(record.id, 'delete')}
          >
            <Button type="primary" danger icon={<AiFillDelete size={20} />}>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];
}
